// What to show when a request fails (a network error, a 5xx, a rejected form). Pages call it from `.catch`:
//
//     axios.get(...).then(...).catch(error => showError(this, error, 'Záznam se nepodařilo načíst.'))
//
// The message of the server is used when there is one, otherwise `fallback`. A rejected form (422) also
// fills `errors` of the page, which the form fields show. A 401 is not reported: the session has expired
// and the application already sends the user to the login page.
export function errorMessage(error, fallback) {
    const message = error && error.response && error.response.data && error.response.data.message;
    return typeof message === 'string' && message !== '' ? message : fallback;
}

export function showError(vm, error, fallback) {
    const response = error && error.response;
    if (response && response.status === 401) {
        return;
    }
    if (response && response.status === 422 && response.data && response.data.errors && 'errors' in vm.$data) {
        vm.errors = response.data.errors;
    }
    vm.$toast.error(errorMessage(error, fallback));
}
